import React from "react";
import Cart from "../components/ShoppingCart/Cart";
import { getStore } from "../components/Stores";
import { Redirect, maintenanceMode } from "../components/Utilities";

interface Props {
  Title: string;
  Params?: any;
}

interface State {
  mcode: string;
  isMaintenanceMode: boolean;
  devMode: any;
}

class ShoppingCart extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      mcode: "",
      isMaintenanceMode: false,
      devMode: null,
    };
  }

  componentDidMount(): void {
    const { mcode } = this.props.Params;
    let mode: boolean = maintenanceMode(mcode);
    this.setState({ isMaintenanceMode: mode });
  }

  render() {
    return (
      <div className="wrapper">
        <div className="section latest-offers">
          <div className="container">
            <h3 className="section-title">{this.props.Title}</h3>
            <hr />
            <Cart key={"ShoppingCart"} />
            {this.state.isMaintenanceMode && <Redirect path="/Maintenance" />}
          </div>
        </div>
      </div>
    );
  }
}

export default ShoppingCart;
